import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-invert-provided.png'


const _withScopeId = n => (_pushScopeId("data-v-9d520264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "topBar" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "registerInfo"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" We are committed to privacy and transparency. In this context, we adhere to the Code of Conducts and publishing obligations of the ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://ec.europa.eu/info/about-european-commission/service-standards-and-principles/transparency/transparency-register_en",
  target: "_blank"
}, "EU transparency register", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" (TR-Q-2017-22465) and the ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.lobbyregister.bundestag.de/startseite?lang=de",
  target: "_blank"
}, "German lobby register", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" (R001575). ")
const _hoisted_11 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_13 = { class: "linkColumns" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Explore", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Tech Policy")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Venture Building")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Community Building")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Events")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("News")
const _hoisted_21 = { class: "col" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Company", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Team & Partners")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Jobs")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_27 = { class: "col" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Legal", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cookieLabel" }, "Change cookie preferences", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "cookieArrow",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 17 L17 7 M9 7 H17 V15",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "logoImage",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:'HomeView'})))
        }),
        (_ctx.registerInfo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "registerInfo",
              innerHTML: _ctx.registerInfo
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_11))
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("nav", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_router_link, { to: "/tech-policy" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/venture-building" }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/community-building" }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/events" }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/news" }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _createElementVNode("nav", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/team" }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/jobs" }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/contact" }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ]),
        _createElementVNode("nav", _hoisted_27, [
          _hoisted_28,
          (_ctx.conduct.url)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: _ctx.conduct.url
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.conduct.title), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legalLinks, (elm, ind) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: ind,
              to: elm.url
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(elm.title), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          _createElementVNode("span", {
            class: "cookieTrigger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openCookies')))
          }, _hoisted_31)
        ])
      ]),
      _createElementVNode("span", _hoisted_32, "© " + _toDisplayString((new Date().getFullYear())) + " iconomy GmbH", 1)
    ])
  ]))
}